import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import * as api from '~/Services/Service';

const validationSchema = Yup.object().shape({
  descricao: Yup.string()
    .required('Descrição é obrigatória')
    .max(30, 'Máximo 30 caracteres'),
});

const ModalPais = (props) => {
  const { show, onHide, pais, onSalvar } = props;

  const ehEdicao = pais != null;

  const getInitialValues = () => {
    if (ehEdicao) {
      return {
        codigo: pais.codigo,
        descricao: pais.descricao || '',
      };
    }
    return {
      descricao: '',
    };
  };

  const handleSubmit = async (values, formikBag) => {
    try {
      if (ehEdicao) {
        await api.atualizarPais({ codigo: values.codigo, descricao: values.descricao });
        toast.success('País atualizado com sucesso.');
      } else {
        await api.criarPais({ descricao: values.descricao });
        toast.success('País criado com sucesso.');
      }
      onSalvar();
      onHide();
    } catch (err) {
      toast.error((err && err.message) ? err.message : 'Erro ao salvar país.');
    } finally {
      formikBag.setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton style={{ backgroundColor: '#0747a6', color: '#fff' }}>
        <Modal.Title style={{ fontSize: '1rem', color: '#fff' }}>
          {ehEdicao ? 'Editar País' : 'Novo País'}
        </Modal.Title>
      </Modal.Header>

      <Formik
        initialValues={getInitialValues()}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {(formik) => {
          return (
            <Form onSubmit={formik.handleSubmit}>
              <Modal.Body>
                {ehEdicao && (
                  <Form.Group className="mb-2">
                    <Form.Label as="small" className="mb-0">Código</Form.Label>
                    <Form.Control
                      type="text"
                      value={formik.values.codigo}
                      readOnly
                      style={{ backgroundColor: '#f5f5f5' }}
                    />
                  </Form.Group>
                )}
                <Form.Group className="mb-2">
                  <Form.Label as="small" className="mb-0">
                    Descrição <span className="text-danger">*</span>
                  </Form.Label>
                  <Field
                    as={Form.Control}
                    type="text"
                    name="descricao"
                    maxLength={30}
                    style={{ textTransform: 'uppercase' }}
                    isInvalid={formik.touched.descricao && !!formik.errors.descricao}
                  />
                  <ErrorMessage
                    name="descricao"
                    component="div"
                    className="invalid-feedback d-block"
                    style={{ fontSize: '0.75rem' }}
                  />
                </Form.Group>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="secondary" onClick={onHide} disabled={formik.isSubmitting}>
                  Cancelar
                </Button>
                <Button variant="primary" type="submit" disabled={formik.isSubmitting}>
                  {formik.isSubmitting ? 'Salvando...' : 'Salvar'}
                </Button>
              </Modal.Footer>
            </Form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default ModalPais;
